import { customFetch } from '#/services/customFetch'
import type { Testimonial } from '../types/testimonial.types'

export async function getTestimonials(): Promise<Testimonial[]> {
  return customFetch<Testimonial[]>('/student/testimonials')
}
